import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Show } from "../../../hooks/Show";

class Sidebar extends Component {
  render() {
    return (
      <ul
        className={
          "navbar-nav bg-default sidebar sidebar-dark accordion shadow"
        }
        id="accordionSidebar"
      >
        <a
          className="sidebar-brand d-flex align-items-center justify-content-center"
          href="/dashboard"
        >
          <img
            className="img-responsive sidebar-brand-image"
            src="https://scontent.fpei1-1.fna.fbcdn.net/v/t1.18169-9/26165289_375180046264698_4541341282296257735_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=09cbfe&_nc_eui2=AeHP4_-jE6tnHpEukkE9A1_Si5YvJp7SzqyLli8mntLOrGteNWQT18pf2wCBzqF0EiLFxPvh36NhYaWz5-HHcjaw&_nc_ohc=mkq9eaQqe08AX-Conic&_nc_ht=scontent.fpei1-1.fna&oh=00_AT8L7s-hDwrwVYcgp3oIxfZQkBjdwyJW5mwWgEGkvLMqJg&oe=6324C2B8"
          />
        </a>
        <hr className="sidebar-divider" />
        <div className="sidebar-heading">Administración</div>
        <Show when="feature:see-dashboard">
          <li className="nav-item">
            <Link className="nav-link" to="/dashboard">
              <i className="fas fa-fw fa-tachometer-alt"></i>
              <span>Dashboard</span>
            </Link>
          </li>
        </Show>
        <Show when="feature:see-applications">
          <li className="nav-item">
            <a
              className="nav-link collapsed"
              href="#"
              data-toggle="collapse"
              data-target="#collapse"
              aria-controls="collapse"
            >
              <i className="fas fa-address-card"></i>
              <span>Solicitudes</span>
            </a>
            <div
              id="collapse"
              className="collapse"
              aria-labelledby="collapse"
              data-parent="#accordionSidebar"
            >
              <div className="bg-white py-2 collapse-inner rounded">
                <Show when="feature:read-naturalPersons">
                  <Link className="collapse-item" to="/naturalPersons">
                    Personas Naturales
                  </Link>
                </Show>
                <Show when="feature:read-juridicalPersons">
                  <Link className="collapse-item" to="/juridicalPersons">
                    Personas Jurídicas
                  </Link>
                </Show>
              </div>
            </div>
          </li>
        </Show>

        <Show when="feature:menu-security">
          <hr className="sidebar-divider" />
          <div className="sidebar-heading">Configuración</div>

          <li className="nav-item">
            <a
              className="nav-link collapsed"
              href="#"
              data-toggle="collapse"
              data-target="#collapse2"
              aria-controls="collapse2"
            >
              <i className="fas fa-shield-alt"></i>
              <span>Seguridad</span>
            </a>
            <div
              id="collapse2"
              className="collapse"
              aria-labelledby="collapse2"
              data-parent="#accordionSidebar"
            >
              <div className="bg-white py-2 collapse-inner rounded">
                <Show when="feature:read-role">
                  <Link className="collapse-item" to="/roles">
                    Roles
                  </Link>
                </Show>
                <Show when="feature:read-permission">
                  <Link className="collapse-item" to="/permissions">
                    Permisos
                  </Link>
                </Show>
                <Show when="feature:read-user">
                  <Link className="collapse-item" to="/users">
                    Usuarios
                  </Link>
                </Show>
              </div>
            </div>
          </li>
        </Show>
      </ul>
    );
  }
}

export default Sidebar;
